<div id="irt-vehicle-detail-gallery-root-layout" class="irt-full-width irt-full-height">
  <div id="irt-vehicle-detail-gallery-img-layout" class="irt-full-width irt-full-height irt-border-radius"
       *ngIf="vehicleContent.img_url && vehicleImageUrl"
       [ngStyle]="{'background-image':'url(' + vehicleImageUrl + ')'}"></div>

  <div class="irt-full-width irt-full-height irt-centered-row" *ngIf="!vehicleContent.img_url">
    <p class="irt-centered-text"> Non ci sono immagini per questo veicolo </p>
  </div>
</div>
